import "./Transactions.scss";

export default function Transactions() {
  return (
    <div className="transactions spacing">
      <h1>Avg. Transaction Speed: 2 Seconds</h1>
      <p>
        Most payments are confirmed almost instantly for smooth, real-time
        processing.
      </p>
    </div>
  );
}
